import { render, staticRenderFns } from "./goal-setting.page.vue?vue&type=template&id=00ea8612&scoped=true"
import script from "./goal-setting.page.vue?vue&type=script&lang=ts"
export * from "./goal-setting.page.vue?vue&type=script&lang=ts"
import style0 from "./goal-setting.page.vue?vue&type=style&index=0&id=00ea8612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea8612",
  null
  
)

export default component.exports